/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import datetimeTemplate from './datetime.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('tektelic.components.datetime', [])
    .directive('tkDatetime', Datetime)
    .name;

/*@ngInject*/
function Datetime($compile, $templateCache) {

    var linker = function (scope, element, attrs, ngModelCtrl) {

        var template = $templateCache.get(datetimeTemplate);
        element.html(template);

        ngModelCtrl.$render = function () {
            if (ngModelCtrl.$viewValue) {
                var value = ngModelCtrl.$viewValue;
                scope.date = new Date(value);
            }
            scope.updateMinMaxDates();
        }

        scope.updateMinMaxDates = function () {
            scope.minDate = new Date();
        }

        scope.updateView = function () {
            var value = null;
            if (scope.date) {
                truncateToMinutes(scope.date);
                value = scope.date.getTime();
                ngModelCtrl.$setValidity('required', true);
            } else {
                ngModelCtrl.$setValidity('required', !scope.required);
            }
            ngModelCtrl.$setViewValue(value);
        }

        scope.$watch('required', function () {
            scope.updateView();
        });

        scope.$watch('date', function (newDate) {
            if (newDate) {
                if (newDate.getTime() < scope.minDate) {
                    scope.date = angular.copy(scope.minDate);
                } else if (newDate.getTime() > scope.maxDate) {
                    scope.date = angular.copy(scope.maxDate);
                }
            }
            scope.updateView();
        });

        function truncateToMinutes(date) {
            date.setSeconds(0, 0);
        }

        $compile(element.contents())(scope);

    }

    return {
        restrict: "E",
        require: "^ngModel",
        scope: {
            required: '=ngRequired'
        },
        link: linker
    };
}



// WEBPACK FOOTER //
// ./src/app/components/datetime.directive.js